import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { getCode } from 'app/utils/method';

/**
 * Trip Liquidation Cell Renderer
 * Displays trip code and ID with clickable link to monitor screen
 */
@Component({
  selector: 'app-trip-liquidation-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="flex flex-col">
      <span class="font-bold text-xs" *ngIf="tripCode">{{ tripCode }}</span>
      <div
        class="flex items-center cursor-pointer"
        [ngClass]="{ underline: hasTripId }"
        (click)="onTripClick()"
        [matTooltip]="hasTripId ? 'Ir al viaje' : ''">
        <span>{{ tripDisplay }}</span>
        <mat-icon
          *ngIf="hasTripId"
          class="ml-2 icon-size-3 hover:animate-bounce"
          svgIcon="heroicons_outline:rocket-launch"
          style="color: rgb(0, 0, 0)">
        </mat-icon>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .underline {
      text-decoration: underline;
    }
  `]
})
export class TripLiquidationCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  constructor(private router: Router) {}

  get tripCode(): string | null {
    return getCode(this.params?.data?.trip);
  }

  get tripDisplay(): string {
    return this.params?.data?.tripId?.toString() ?? '-';
  }

  get hasTripId(): boolean {
    return !!this.params?.data?.tripId;
  }

  onTripClick(): void {
    if (this.hasTripId && this.params?.data?.tripId) {
      const tripId = this.params.data.tripId;
      const queryParams = { tripId };
      const urlTree = this.router.createUrlTree(
        ['monitor', 'principal-screen'],
        { queryParams }
      );
      const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, '_blank');
    }
  }
}
